(function(){
'use strict';

/**
 * @name encodeURI
 * @kind filter
 */

function encodeURIFilter() {
  return function (input) {
    return encodeURI(input);
  };
}

angular.module('classy').filter('encodeURI', encodeURIFilter);
})();